import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BlacklistSection } from "./blacklist/BlacklistSection";
import ExclusivitySection from "./exclusivity/ExclusivitySection";

const ActionButtonWithInfo = ({
  label,
  infoText,
  onClick,
  variant,
  color,
  isReadOnly,
}: {
  label: string;
  infoText: string;
  onClick: () => void;
  variant: "outlined" | "contained";
  color: "error" | "primary";
  isReadOnly: boolean;
}) => (
  <Box display="flex" alignItems="center" gap={2}>
    <Button
      variant={variant}
      color={color}
      sx={{ borderRadius: "24px", minWidth: "183px" }}
      onClick={onClick}
      disabled={isReadOnly}
    >
      {label}
    </Button>
    <Typography variant="body2" color="textSecondary">
      {infoText}
    </Typography>
  </Box>
);

type Props = {
  isReadOnly: boolean;
};

export const PoolProPage = ({ isReadOnly }: Props) => {
  const { t } = useTranslation();

  const [isExclusivityDialogOpen, setIsExclusivityDialogOpen] = useState(false);
  const [isBlacklistDialogOpen, setIsBlacklistDialogOpen] = useState(false);

  return (
    <>
      <Box mb={3} mt={1}>
        <ActionButtonWithInfo
          variant="outlined"
          color="error"
          label={t("talentProfile:newBlacklist")}
          infoText={t("talentProfile:blacklistInfoText")}
          onClick={() => setIsBlacklistDialogOpen(true)}
          isReadOnly={isReadOnly}
        />
      </Box>
      <ActionButtonWithInfo
        variant="contained"
        color="primary"
        label={t("talentProfile:newExclusivity")}
        infoText={t("talentProfile:exclusivityInfoText")}
        onClick={() => setIsExclusivityDialogOpen(true)}
        isReadOnly={isReadOnly}
      />
      <Box mt={5}>
        <BlacklistSection
          isAddDialogOpen={isBlacklistDialogOpen}
          onAddDialogClose={() => setIsBlacklistDialogOpen(false)}
        />
        <ExclusivitySection
          isAddDialogOpen={isExclusivityDialogOpen}
          onAddDialogClose={() => setIsExclusivityDialogOpen(false)}
        />
      </Box>
    </>
  );
};
